import {
  SCHEDULE_STOP_SYNCING_EVENT
} from 'infra/actions/types'

const stopEventSync = eventId => ({
  type: SCHEDULE_STOP_SYNCING_EVENT,
  eventId
})

export default stopEventSync



// WEBPACK FOOTER //
// ./src/infra/actions/events/stopEventSync.js